<template>
  
   <a-card :bordered='false'>
     <SmallSquare content='可设置多种支付方式（微信支付、货到付款），自由启用对应支付方式。' :padding='false' />
     <div class='m-b-25 m-t-20'>
      <span >
        <a-button type="primary" v-has:wxPaymentCreate="()=>{visible = true}">
          <PlusOutlined />
          添加支付方式
        </a-button>
      </span>
     </div>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
        <template v-slot:action="{ record }">
          <a-dropdown>
            <a class="ant-dropdown-link"> 操作
              <DownOutlined />
            </a>
            <template v-slot:overlay>
              <a-menu>
                <a-menu-item>
                  <a v-has:wxPaymentStatus="()=>payTypeStatus(record)" href="javascript:;">{{record.status ? '不启用':'启用'}}</a>
                </a-menu-item>
                <a-menu-item>
                  <a v-has:wxPaymentEditKey="()=> {$router.push('/system/setting/payment/edit_key?id='+record.id)}" href="javascript:;">编辑Key</a>
                </a-menu-item>
                <a-menu-item>
                  <a v-has:wxPaymentDel="()=>payTypeDel(record.id)" href="javascript:;">删除</a>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </template>
      </a-table>
    </a-card>
    <a-modal  :keyboard="false" title="添加支付方式" :width='800' centered :footer="null" v-model:visible="visible" destroyOnClose>
      <a-table :pagination='false' :loading='paylistLoading' bordered rowKey='id' :columns='paycolumns' :data-source='paydata'>
        <template v-slot:action="{ record }">
          <a-button type="primary" :disabled="record.is_bind == 1" @click='payTypeAdd(record.id)'>{{record.is_bind == 1 ? '已添加':'添加'}}</a-button>
        </template>
      </a-table>
    </a-modal>
</template>
<script>
  import { DownOutlined,PlusOutlined } from "@ant-design/icons-vue";
import { ref, onMounted, reactive, toRefs,inject } from 'vue';
import { message } from 'ant-design-vue';
import { getRouter } from '@/utils/app';
import { getPayList,getPayTypeList,addPay,getPayStatus,getPayDel } from '@/api/system';
import { iscode } from '@/utils/app';
export default {
  components: { DownOutlined,PlusOutlined },
  setup(props) {
    // 列表数据和列头配置
    let data = ref();
    let paydata = ref();
    const state = reactive({
      listLoading: false,
      paylistLoading:false,
      visible:false
    });
    let columns = [
      {
        title: '支付方式',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '启用状态',
        dataIndex: 'status',
        customRender: ({record}) => {
          return record.status == 1 ? '已启用' : '未启用'
        }
      },
      {
        title: '操作',
        key: 'action',
        width:150,
        slots: { customRender: 'action' },
      },
    ];
    let paycolumns = [
      {
        title: '支付接口',
        dataIndex: 'name',
        key: 'name',
        width:100,
      },
      {
        title: '描述',
        dataIndex: 'describe',
        key: 'describe',
      },
      {
        title: '操作',
        key: 'action',
        width:100,
        slots: { customRender: 'action' },
      },
    ];
    const $Modal = inject('$Modal')
    // 获取支付列表
    const getPayType = async() =>{
      state.paylistLoading = true;
      try {
        let res = await getPayTypeList().then(res=>res.data);
        state.paylistLoading = false;
        if (iscode(res)) {
          paydata.value = res.data;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.paylistLoading = false;
      }
    }
    //添加支付方式
    const payTypeAdd = async(id) =>{
      $Modal.confirm({
        centered:true,
        title:'添加支付方式',
        content: '您确定要添加该支付方式么吗？', onOk:async () => {
          let res = await addPay({pay_list_id:id}).then(res=>res.data);
          if (iscode(res,true)) {
            state.visible = false
            initData()
            getPayType()
          }
        }
      })
    }
    //删除支付方式
    const payTypeDel = async(id) =>{
      $Modal.confirm({
        centered:true,
        title:'删除支付方式',
        content: '您确定要删除该支付方式么吗？', onOk:async () => {
          let res = await getPayDel({id:id}).then(res=>res.data);
          if (iscode(res,true)) {
            initData()
            getPayType()
          }
        }
      })
    }
    //修改支付方式状态e
    const payTypeStatus = async(e) =>{
      $Modal.confirm({
        centered:true,
        title:'操作提示',
        content: '您确定要'+(e.status ? '禁用':'启用')+'该支付方式么吗？', onOk:async () => {
          let res = await getPayStatus({status:e.status==1?0:1,id:e.id}).then(res=>res.data);
          if (iscode(res,true)) {
            initData()
          }
        }
      })
    }
    // 获取支付管理列表
    const initData = async () => {
      state.listLoading = true;
      try {
        let res = await getPayList().then(res=>res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    onMounted(() => {
      initData();
      getPayType();
    });
    return {
      ...toRefs(state),
      data,
      paydata,
      columns,
      paycolumns,
      payTypeAdd,
      payTypeDel,
      payTypeStatus
    };
  },
};
</script>